import SharedPropsService from "../../SharedPropsService";
import { rebuildLeadMobileCardBuilder, rebuildLeadsTable, searchObject, sideBarNavigate, sortPartnerObjectByProperty } from "../partnerWeb_Dashboard/utils";
import { ROUTE } from "../../routes";
import { partnerApi, StoreKey } from "../../configs/api";
import { AppLink, VoltWebSiteBaseLink } from "../../configs/constants";
import { generateUniqueId, isPartnerAffiliated } from "../../configs/utils";
import { getAppHeader } from "../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
let PartnerLeadsData = [];
let PartnerLeadsDataOriginal = {
    customerMetadataList: [],
    nextToken: null,
};
let tableSearchString = '';
let ascOrder = true;
// export const itemsPerPage_Leads = 5;
// export let startIndex_Leads = 0;
// let pageCount = 0;
export const onLoadLeadsAction = async (action, _datastore, { setDatastore, navigate, network, asyncStorage, }) => {
    console.warn('**** onLoadLeadsAction Action Triggered ****', action);
    PartnerLeadsData = { ...(await SharedPropsService.getPartnerLeadsList()) }
        ?.customerMetadataList;
    // PartnerLeadsData = { ...(await SharedPropsService.getPartnerLeadsList()) }
    //     ?.customerMetadataList.slice(startIndex_Leads, startIndex_Leads + itemsPerPage_Leads);
    PartnerLeadsDataOriginal = {
        ...(await SharedPropsService.getPartnerLeadsList()),
    };
};
export const getPendingCustomerDetails = async (action, _datastore, { setDatastore, navigate, network, asyncStorage }) => {
    const searchContext = action?.payload?.searchContext;
    const currentPage = action?.payload?.currentPage || 1;
    await setDatastore(ROUTE.PARTNER_LEAD, 'pendingApplicationScreen', {
        PendingCustomerData: {},
        pendingDataFetched: false,
    });
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const response = await network.post(`${partnerApi.getAllPendingApplicationDetails}${partnerAccountId}/allapplication/${currentPage}`, {
        searchContext: searchContext || "",
    }, { headers: await getAppHeader() });
    if (response?.status === 200) {
        await setDatastore(ROUTE.PARTNER_LEAD, 'pendingApplicationScreen', {
            PendingCustomerData: response?.data,
            pendingDataFetched: true,
        });
    }
};
export const getPendingRegisteredCustomerDetails = async (action, _datastore, { setDatastore, navigate, network, asyncStorage }) => {
    const searchContext = action?.payload?.searchContext;
    const currentPage = action?.payload?.currentPage || 1;
    await setDatastore(ROUTE.PARTNER_LEAD, 'pendingApplicationScreen', {
        PendingCustomerData: {},
        pendingDataFetched: false,
    });
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const response = await network.post(`${partnerApi.getAllPendingApplicationDetails}${partnerAccountId}/registrationpending/${currentPage}`, {
        searchContext: searchContext || "",
    }, { headers: await getAppHeader() });
    if (response?.status === 200) {
        await setDatastore(ROUTE.PARTNER_LEAD, 'pendingApplicationScreen', {
            PendingCustomerData: response?.data,
            pendingDataFetched: true,
        });
    }
};
export const getCompletedRegisteredCustomerDetails = async (action, _datastore, { setDatastore, navigate, network, asyncStorage }) => {
    const searchContext = action?.payload?.searchContext;
    const currentPage = action?.payload?.currentPage || 1;
    await setDatastore(ROUTE.PARTNER_LEAD, 'pendingApplicationScreen', {
        PendingCustomerData: {},
        pendingDataFetched: false,
    });
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const response = await network.post(`${partnerApi.getAllPendingApplicationDetails}${partnerAccountId}/registrationcompleted/${currentPage}`, {
        searchContext: searchContext || "",
    }, { headers: await getAppHeader() });
    if (response?.status === 200) {
        await setDatastore(ROUTE.PARTNER_LEAD, 'pendingApplicationScreen', {
            PendingCustomerData: response?.data,
            pendingDataFetched: true,
        });
    }
};
export const onTrackPendingCustomerJourney = async (action, _datastore, standardUtilities) => {
    const customerType = action?.payload?.customerType;
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const currentPage = action?.payload?.currentPage || 1;
    const searchContext = action?.payload?.searchContext;
    if (customerType === 'PENDING_REGISTRATION') {
        standardUtilities.instrumentTrack("ASSISTED_JOURNEY_BUTTON_CLICKED", {
            "page": "leads"
        });
        const pan = action?.payload?.pan;
        const phoneNumber = action?.payload?.phoneNumber;
        const preFill = action?.payload?.preFill;
        if (preFill) {
            await standardUtilities.navigate(ROUTE.REGISTER_LEADS, { isPrevRouteLeads: true, pan, phoneNumber, preFill });
        }
        else {
            await standardUtilities.navigate(ROUTE.REGISTER_LEADS, { isPrevRouteLeads: true, currentActiveTabIndex: currentActiveTabIndex, currentPage: currentPage, searchContext: searchContext });
        }
    }
    else {
        const trackingId = await generateUniqueId();
        await AsyncStorage.setItem('trackingId', trackingId);
        standardUtilities.instrumentTrack('PLJ_LOAD_INITIATED', { trackingId: trackingId });
        const user = action.payload.value;
        const borrowerAccountId = user?.accountId;
        const userName = user.fullName;
        const applicationId = user?.applicationId;
        const phoneNumber = user?.phoneNumber;
        await AsyncStorage.setItem("pljName", userName);
        await standardUtilities.asyncStorage.set(StoreKey.PLJ_borrowerAccountId, borrowerAccountId);
        await standardUtilities.navigate(ROUTE.VOLT_APP, { borrowerAccountId: borrowerAccountId, name: userName, userApplicationId: applicationId, phoneNumber: phoneNumber, currentActiveTabIndex: currentActiveTabIndex, currentPage: currentPage, searchContext: searchContext });
    }
};
export const onSearchLead = async (action, _datastore, standardUtilities) => {
    console.warn('**** onSearchLead Action Triggered ****', action);
    //reset the filter
    //web
    await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'all_Filter', {
        selected: true
    });
    await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationCompleted_Filter', {
        selected: false
    });
    await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationPending_Filter', {
        selected: false
    });
    //mob
    await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationCompleted_Filter_Mob', {
        selected: false
    });
    await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'all_Filter_Mob', {
        selected: true
    });
    await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationPending_Filter_Mob', {
        selected: false
    });
    tableSearchString = action.payload.value;
    const user = JSON.parse(await standardUtilities.asyncStorage.get(StoreKey.userContext));
    const partnerAccountType = user?.linkedPartnerAccounts[0].partnerAccountType;
    PartnerLeadsDataOriginal = await SharedPropsService.getPartnerLeadsList();
    const PartnerLeadsDataAfterSearch = PartnerLeadsDataOriginal?.customerMetadataList.filter(data => {
        const results = searchObject(data, tableSearchString);
        if (results &&
            results.length > 0) {
            return true;
        }
        else {
            return false;
        }
    });
    if (action.payload.widgetId === 'leadSeachInput') {
        await rebuildLeadsTable(standardUtilities, PartnerLeadsDataAfterSearch, action, partnerAccountType, user);
    }
    if (action.payload.widgetId === 'leadsMobRootSearchInput') {
        await rebuildLeadMobileCardBuilder(standardUtilities, PartnerLeadsDataAfterSearch, partnerAccountType, user);
    }
};
export const onSortLeads = async (action, _datastore, standardUtilities) => {
    console.warn('**** onSortLeads leads Action Triggered ****', action);
    const user = JSON.parse(await standardUtilities.asyncStorage.get(StoreKey.userContext));
    const partnerAccountType = user?.linkedPartnerAccounts[0].partnerAccountType;
    PartnerLeadsData = sortPartnerObjectByProperty(PartnerLeadsData, action.payload.value, ascOrder);
    ascOrder = !ascOrder;
    await rebuildLeadsTable(standardUtilities, PartnerLeadsData, action, partnerAccountType, user);
};
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    console.warn('**** onChangeTab leads Action Triggered ****', action);
    await sideBarNavigate(standardUtilities, action);
};
export const onLoadMoreData = async (action, _datastore, standardUtilities) => {
    console.warn('**** onLoadMoreData leads Action Triggered ****', action);
};
export const onTrackCustomerJourney = async (action, _datastore, standardUtilities) => {
    console.warn('**** onLoadMoreData leads Action Triggered ****', action);
    const trackingId = await generateUniqueId();
    await AsyncStorage.setItem('trackingId', trackingId);
    standardUtilities.instrumentTrack('PLJ_LOAD_INITIATED', { trackingId: trackingId });
    const user = action.payload.value;
    const borrowerAccountId = user?.creditApplication.accountId;
    await AsyncStorage.setItem("pljName", '');
    if (user?.borrowerAccountProfile?.name) {
        await AsyncStorage.setItem("pljName", user?.borrowerAccountProfile?.name);
    }
    await standardUtilities.asyncStorage.set(StoreKey.PLJ_borrowerAccountId, borrowerAccountId);
    await standardUtilities.navigate(ROUTE.VOLT_APP, { borrowerAccountId: borrowerAccountId, name: user?.borrowerAccountProfile?.name, userDetails: user });
};
export const onRegisterLeads = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack("ASSISTED_JOURNEY_BUTTON_CLICKED", {
        "page": "leads"
    });
    const pan = action?.payload?.pan;
    const phoneNumber = action?.payload?.phoneNumber;
    const preFill = action?.payload?.preFill;
    if (preFill) {
        await navigate(ROUTE.REGISTER_LEADS, { isPrevRouteLeads: true, pan, phoneNumber, preFill });
    }
    else {
        await navigate(ROUTE.REGISTER_LEADS, { isPrevRouteLeads: true });
    }
};
export const checkLimitMFCViewDetails = async (action, _datastore, { navigate, network, asyncStorage }) => {
    console.warn('**** checkLimitMFCViewDetails Action Triggered ****', action);
    const user = action?.payload.user;
    const customerLeadId = user?.customerLeadId;
    const header = await getAppHeader();
    header['X-EntityType'] = 'PARTNER';
    header['X-AppPlatform'] = 'VOLT_WEB_APP';
    const leadAuthTokenResponse = await network.post(`${partnerApi.getLeadAuthtoken}${customerLeadId}`, {}, { headers: header }, async () => {
        return;
    }, {
        disableDefault: true
    });
    if (leadAuthTokenResponse?.status === 200) {
        const leadAuthToken = leadAuthTokenResponse?.data?.jwt;
        await navigate(ROUTE.VOLT_APP, {
            isFromCheckLimitMFC: true,
            leadAuthToken: leadAuthToken,
            user: user,
            isFromNonRegisteredCustomer: true
        });
    }
};
export const viewDetails = async (action, _datastore, standardUtilities) => {
    console.warn('**** viewDetails Action Triggered ****', action);
    const user = action?.payload.user;
    if (user) {
        standardUtilities.navigate(ROUTE.PARTNER_VIEW_DETAIL_LEAD, { user: user, leads: true });
    }
};
export const checkPendingCustomerViewDetails = async (action, _datastore, { navigate, network, asyncStorage }) => {
    const customerType = action?.payload?.customerType;
    const pendingCustomerData = action?.payload?.customerData;
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const currentPage = action?.payload?.currentPage;
    const searchContext = action?.payload?.searchContext;
    if (customerType === 'PENDING_REGISTRATION') {
        const customerLeadId = pendingCustomerData?.leadId;
        const header = await getAppHeader();
        header['X-EntityType'] = 'PARTNER';
        header['X-AppPlatform'] = 'VOLT_WEB_APP';
        const leadAuthTokenResponse = await network.post(`${partnerApi.getLeadAuthtoken}${customerLeadId}`, {}, { headers: header }, async () => {
            return;
        }, {
            disableDefault: true
        });
        if (leadAuthTokenResponse?.status === 200) {
            const leadAuthToken = leadAuthTokenResponse?.data?.jwt;
            const phoneNumber = pendingCustomerData?.phoneNo ? pendingCustomerData?.phoneNo : pendingCustomerData?.leadPhoneNumber;
            const link = `${AppLink}?user=${phoneNumber?.slice(3)}`;
            await navigate(ROUTE.VOLT_APP, {
                isFromCheckLimitMFC: true,
                leadAuthToken: leadAuthToken,
                user: pendingCustomerData,
                isFromNonRegisteredCustomer: true,
                currentActiveTabIndex: currentActiveTabIndex,
                currentPage: currentPage,
                searchContext: searchContext,
                shareLink: link,
            });
        }
    }
    else {
        await navigate(ROUTE.PENDING_CUSTOMER_VIEW_DETAILS_SCREEN, { pendingCustomerData, currentActiveTabIndex, currentPage, searchContext });
    }
};
export const onShareLink = async (action, _datastore, standardUtilities) => {
    console.warn('**** onShareLink Action Triggered ****', action);
    const user = action?.payload.user;
    console.log("User 123: ", user);
    const phoneNumber = user.borrowerAccountProfile.phoneNumber ? user.borrowerAccountProfile.phoneNumber : '';
    const link = `${AppLink}?user=${phoneNumber.slice(3)}&sts=1`;
    if (user) {
        standardUtilities.navigate(ROUTE.INVITE_CLIENT, {
            _link: link,
            _title: 'Directly share the Volt Money app link with your customers.',
            _headerTitle: 'Share link with customer',
            _removeBanner: true
        });
    }
};
export const onSharePendingCustomerLink = async (action, _datastore, standardUtilities) => {
    const user = action?.payload.user;
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const currentPage = action?.payload?.currentPage || 1;
    const customerData = action?.payload?.customerData;
    const userPhoneNumber = customerData?.phoneNumber;
    const searchContext = action?.payload?.searchContext;
    const phoneNumber = userPhoneNumber ? userPhoneNumber : user?.borrowerAccountProfile?.phoneNumber ? user?.borrowerAccountProfile?.phoneNumber : '';
    const link = `${AppLink}?user=${phoneNumber?.slice(3)}`;
    if (user || phoneNumber) {
        standardUtilities.navigate(ROUTE.INVITE_CLIENT, {
            _link: link,
            _title: 'Directly share the Volt Money app link with your customers.',
            _headerTitle: 'Share link with customer',
            _removeBanner: true,
            currentPendingCustomerActiveTabIndex: currentActiveTabIndex,
            currentPage: currentPage,
            searchContext: searchContext,
        });
    }
};
export const clearSearchText = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.PARTNER_LEAD, 'pendingApplicationScreen', {
        currentSearchContext: '',
    });
};
export const viewPendingCustomerDetails = async (action, _datastore, standardUtilities) => {
    console.warn('**** viewDetails Action Triggered ****', action);
    const customerType = action?.payload?.customerType;
    const user = action?.payload.user;
    if (user) {
        standardUtilities.navigate(ROUTE.PARTNER_VIEW_DETAIL_LEAD, { user: user, leads: true });
    }
};
export const onShareLinkWithRef = async (action, _datastore, standardUtilities) => {
    standardUtilities.instrumentTrack("INVITE_CLIENT_BUTTON CLICKED", {
        "page": "leads"
    });
    console.warn('**** onShareLinkWithRef Action Triggered ****', action);
    const user = JSON.parse(await standardUtilities.asyncStorage.get(StoreKey.userContext));
    const refCode = user?.linkedPartnerAccounts[0]?.partnerCode;
    const accountId = user?.linkedPartnerAccounts[0]?.accountId;
    const partnerAccountType = user?.linkedPartnerAccounts[0]?.partnerAccountType;
    const header = await getAppHeader();
    header["X-AppPlatform"] = 'VOLT_WEB_APP';
    const responseInvestorLink = await standardUtilities.network.get(`${partnerApi.investorLink}${accountId}`, {
        headers: header
    }, async () => {
        return;
    }, {
        isPartnerPlatform: true
    });
    const _link = responseInvestorLink.data.link;
    const link = isPartnerAffiliated(partnerAccountType) ? `${_link}` : `${VoltWebSiteBaseLink}?ref=${refCode}`;
    standardUtilities.navigate(ROUTE.INVITE_CLIENT, { _link: link });
};
export const onFilterLeadsAction = async (action, _datastore, standardUtilities) => {
    console.warn('**** onFilterLeadsAction Action Triggered ****', action);
    const filterType = action.payload.filterType;
    const isMobile = action.payload.isMobile;
    const user = JSON.parse(await standardUtilities.asyncStorage.get(StoreKey.userContext));
    const partnerAccountType = user?.linkedPartnerAccounts[0].partnerAccountType;
    PartnerLeadsDataOriginal = await SharedPropsService.getPartnerLeadsList();
    switch (filterType) {
        case 'Pending registration':
            console.warn('**** Pending registration ****');
            PartnerLeadsData = PartnerLeadsDataOriginal?.customerMetadataList.filter(data => {
                if (data &&
                    data?.currentStepName === 'Pending registration') {
                    return true;
                }
                else {
                    return false;
                }
            });
            //web
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationPending_Filter', {
                selected: true
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'all_Filter', {
                selected: false
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationCompleted_Filter', {
                selected: false
            });
            //mob
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationPending_Filter_Mob', {
                selected: true
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'all_Filter_Mob', {
                selected: false
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationCompleted_Filter_Mob', {
                selected: false
            });
            break;
        case 'Registration complete':
            console.warn('**** Registration completed ****');
            PartnerLeadsData = PartnerLeadsDataOriginal?.customerMetadataList.filter(data => {
                if (data &&
                    data?.currentStepName !== 'Pending registration') {
                    return true;
                }
                else {
                    return false;
                }
            });
            //web
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationCompleted_Filter', {
                selected: true
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'all_Filter', {
                selected: false
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationPending_Filter', {
                selected: false
            });
            //mob
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationCompleted_Filter_Mob', {
                selected: true
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'all_Filter_Mob', {
                selected: false
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationPending_Filter_Mob', {
                selected: false
            });
            break;
        default:
            console.warn('**** All ****');
            PartnerLeadsData = PartnerLeadsDataOriginal?.customerMetadataList;
            //web
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'all_Filter', {
                selected: true
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationCompleted_Filter', {
                selected: false
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationPending_Filter', {
                selected: false
            });
            //mob
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationCompleted_Filter_Mob', {
                selected: false
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'all_Filter_Mob', {
                selected: true
            });
            await standardUtilities.setDatastore(ROUTE.PARTNER_LEAD, 'RegistrationPending_Filter_Mob', {
                selected: false
            });
            break;
    }
    if (isMobile) {
        await rebuildLeadMobileCardBuilder(standardUtilities, PartnerLeadsData, partnerAccountType, user);
    }
    else {
        await rebuildLeadsTable(standardUtilities, PartnerLeadsData, action, partnerAccountType, user);
    }
};
